import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RxjsComponent } from '@smooved/core';
import { takeUntil } from 'rxjs/operators';
import { QuestionContainerType } from '../../enums/question-container-type.enum';
import { Category } from '../../interfaces/meta/category';
import { Question } from '../../interfaces/meta/question';
import { QuestionContainer } from '../../interfaces/meta/question-container';
import { SurveyUtils } from '../../utils/survey.utils';

@Component({
    selector: 'app-category-component',
    templateUrl: './category.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryComponent extends RxjsComponent implements OnInit {
    @Input() category: Category;
    @Input() group: UntypedFormGroup;

    public containerType = QuestionContainerType;

    public ngOnInit(): void {
        this.category.questions.forEach((question) => {
            if (SurveyUtils.isQuestionContainer(question)) {
                (question as QuestionContainer).questions.forEach(this.checkQuestionDepedency);
                return;
            }
            this.checkQuestionDepedency(question as Question);
        });
    }

    public showQuestion(question: Question): boolean {
        if (!question.dependency?.questionId) return true;
        return question.dependency.acceptedValues.includes(this.group.get(question.dependency.questionId)?.get('value')?.value);
    }

    private checkQuestionDepedency = (question: Question): void => {
        if (!question.dependency?.questionId) return;
        this.group
            .get(question.dependency?.questionId)
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(this.enableDependantQuestion(question));

        // handle the pre-set value that is set before subscription
        this.enableDependantQuestion(question)(this.group.get(question.dependency?.questionId).value);
    };

    private enableDependantQuestion(question: Question): (value) => void {
        return (value): void => {
            if (question.dependency.acceptedValues.includes(value?.value)) {
                this.group.get(question.id).enable();
                return;
            }
            this.group.get(question.id).disable();
        };
    }
}
